import { useMeta } from "hooks/useMeta";

import { AccountFormPage } from "./AccountFormPage";
import { ForgotPasswordForm } from "./ForgotPasswordForm";

export const ForgotPasswordPage = () => {
    useMeta({
        title: "Forgot your Liveheats password",
        description:
            "Liveheats is a leading action sport event management platform used by local clubs, regional, state, and national federations around the world.",
    });

    return (
        <AccountFormPage
            title="Password reset"
            actionText="To reset your password, enter the email address you use to sign in."
        >
            <ForgotPasswordForm />
        </AccountFormPage>
    );
};
